import { Marker } from "@/components/Marker";
import { Popup } from "@/components/Popup";
import type { MarkerType } from "@/types";

const MarkersList = ({
  markers,
  removeMarker,
}: {
  markers: MarkerType[];
  removeMarker: (marker: MarkerType) => void;
}) => {
  return markers
    .filter((marker) => marker?.location)
    .map((marker, index) => (
      <div key={index}>
        <Marker lat={marker.lat} lng={marker.lng} location={marker.location} />
        <Popup
          counts={marker.counts}
          lat={marker.lat}
          lng={marker.lng}
          location={marker.location}
          details={marker.isSearch ? "In a 2 mile radius of this location" : "Within this area"}
          onRemove={() => removeMarker(marker)}
        />
      </div>
    ));
};

export default MarkersList;
